export default "__VITE_ASSET__39d48ef2__"